"use client";

import { Dialog } from "@base-ui/react/dialog";
import { XIcon } from "lucide-react";
import { NameFavoriteButtonClient } from "@/app/(main)/names/_components/name-favorite-button-client";
import HeartIcon from "@/components/icons/heart";

export interface BabyNameSearchResult {
  id: string;
  name: string;
  slug: string;
  description: string;
  meaning?: string;
  origin?: string | null;
  actionUrl?: string;
  gender?: number;
  isFavorite?: boolean;
  favoriteCount?: number;
  categories?: {
    id: string;
    name: string;
    slug: string;
  }[];
  detailSections?: unknown[];
}

interface SearchNameCardProps {
  item: BabyNameSearchResult;
}

const SearchNameCard = ({ item }: SearchNameCardProps) => {
  const description = item.meaning || item.description;

  return (
    <Dialog.Root>
      <Dialog.Trigger className="appearance-none border-none bg-transparent p-0 m-0 w-full text-left cursor-pointer">
        <div className="flex flex-col justify-start items-start border-b border-gray-300 cursor-pointer hover:bg-brand-blue-100 py-2 w-full text-left">
          <h2 className="font-bold leading-5 inline-flex items-center text-neutral-900">
            {item.name}{" "}
            {item.isFavorite && (
              <HeartIcon className="size-5 fill-brand-blue-500 stroke-brand-blue-500 ml-1" />
            )}
          </h2>
          {description ? (
            <p className="text-xs leading-4.5 font-medium text-neutral-600 mt-0.5">
              {description}
            </p>
          ) : null}
        </div>
      </Dialog.Trigger>

      <Dialog.Portal>
        <Dialog.Backdrop className="fixed inset-0 z-60 bg-black/40 backdrop-blur-sm transition-opacity" />
        <Dialog.Popup className="fixed top-1/2 left-1/2 z-60 flex w-[90vw] max-w-md -translate-x-1/2 -translate-y-1/2 flex-col rounded-3xl bg-white shadow-2xl outline-none max-h-[90vh] overflow-y-auto">
          <div className="flex items-center justify-between border-b border-gray-200 px-6 py-4">
            <NameFavoriteButtonClient
              id={item.id}
              initialFavorited={Boolean(item.isFavorite)}
            />
            <Dialog.Title className="text-xl font-bold text-gray-900">
              {item.name}
            </Dialog.Title>
            <Dialog.Close className="rounded-full p-2 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600">
              <XIcon className="size-5" />
            </Dialog.Close>
          </div>
          <div className="p-6">
            <Dialog.Description className="text-base font-medium leading-6 text-gray-700">
              {description}
            </Dialog.Description>
          </div>
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default SearchNameCard;
